import React from "react";
import Markdown from "markdown-to-jsx";
import { useTranslation } from "react-i18next";
import styles from "./AssistantMarkdown.module.scss";

function MarkdownTable({ children }) {
  const { t } = useTranslation();
  return (
    <div
      className={styles.tableScroll}
      tabIndex={0}
      role="region"
      aria-label={t("analyticsNew.assistant.table", "Таблица в ответе ассистента")}
    >
      <table>{children}</table>
    </div>
  );
}

function MarkdownLink({ href, title, children }) {
  return href ? (
    <a href={href} title={title} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ) : (
    <span>{children}</span>
  );
}

function MarkdownImage({ alt }) {
  return <span>{alt}</span>;
}

const overrides = { table: MarkdownTable, a: MarkdownLink, img: MarkdownImage };

export default function AssistantMarkdown({ text, streaming = false }) {
  return (
    <Markdown
      className={styles.markdown}
      aria-busy={streaming}
      options={{
        forceBlock: true,
        forceWrapper: true,
        wrapper: "div",
        disableParsingRawHTML: true,
        optimizeForStreaming: false,
        overrides,
      }}
    >
      {text}
    </Markdown>
  );
}
